/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateFlexOnboardingSessionInput = {
  readonly cancelUrl: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly phoneNumber: string;
  readonly successUrl: string;
};

export type CustomerDataForFlexQueryVariables = Exact<{ [key: string]: never }>;

export type CustomerDataForFlexQuery = {
  readonly currentCustomer: {
    readonly __typename: 'Customer';
    readonly id: string;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly phoneNumber: string | null;
  } | null;
};

export type FlexCustomerQueryVariables = Exact<{ [key: string]: never }>;

export type FlexCustomerQuery = {
  readonly flexCustomerData:
    | {
        readonly __typename: 'FlexCustomerData';
        readonly flexPaymentMethods: ReadonlyArray<{
          readonly __typename: 'FlexPaymentMethod';
          readonly brand: string | null;
          readonly expMonth: number | null;
          readonly expYear: number | null;
          readonly last4: string | null;
        }>;
      }
    | { readonly __typename: 'UnableToGetFlexCustomerDataError'; readonly errorMessage: string }
    | null;
};

export type CreateFlexOnboardingSessionMutationVariables = Exact<{
  input: Types.CreateFlexOnboardingSessionInput;
}>;

export type CreateFlexOnboardingSessionMutation = {
  readonly createFlexOnboardingSession:
    | { readonly __typename: 'FlexCustomerAlreadyExistsError'; readonly errorMessage: string }
    | {
        readonly __typename: 'FlexOnboardingSession';
        readonly expiresAt: number;
        readonly redirectUrl: string;
        readonly status: string;
      };
};

export const CustomerDataForFlexDocument = gql`
  query CustomerDataForFlex {
    currentCustomer {
      id
      __typename
      firstName
      lastName
      phoneNumber
    }
  }
`;

export function useCustomerDataForFlexQuery(
  options?: Omit<Urql.UseQueryArgs<CustomerDataForFlexQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CustomerDataForFlexQuery, CustomerDataForFlexQueryVariables>({
    query: CustomerDataForFlexDocument,
    ...options,
  });
}
export const FlexCustomerDocument = gql`
  query FlexCustomer {
    flexCustomerData {
      ... on FlexCustomerData {
        __typename
        flexPaymentMethods {
          __typename
          brand
          expMonth
          expYear
          last4
        }
      }
      ... on UnableToGetFlexCustomerDataError {
        __typename
        errorMessage
      }
    }
  }
`;

export function useFlexCustomerQuery(
  options?: Omit<Urql.UseQueryArgs<FlexCustomerQueryVariables>, 'query'>,
) {
  return Urql.useQuery<FlexCustomerQuery, FlexCustomerQueryVariables>({
    query: FlexCustomerDocument,
    ...options,
  });
}
export const CreateFlexOnboardingSessionDocument = gql`
  mutation CreateFlexOnboardingSession($input: CreateFlexOnboardingSessionInput!) {
    createFlexOnboardingSession(input: $input) {
      __typename
      ... on FlexOnboardingSession {
        expiresAt
        redirectUrl
        status
      }
      ... on FlexCustomerAlreadyExistsError {
        errorMessage
      }
    }
  }
`;

export function useCreateFlexOnboardingSessionMutation() {
  return Urql.useMutation<
    CreateFlexOnboardingSessionMutation,
    CreateFlexOnboardingSessionMutationVariables
  >(CreateFlexOnboardingSessionDocument);
}
